import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchLayout = createAsyncThunk("group/fetchLayout", async () => {
  const response = await fetch(`https://api.nilecabins.com/Layout`);
  const layoutData = await response.json();
  return layoutData;
});

const layoutDataSlice = createSlice({
  name: "layoutData",
  initialState: {
    layoutData: [],
    loading: true, // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLayout.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLayout.fulfilled, (state, action) => {
        state.loading = false;
        // Add any fetched dining data to the array
        state.layoutData = action.payload;
      })
      .addCase(fetchLayout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default layoutDataSlice.reducer;
